"use client";

import { c as _c } from "react/compiler-runtime";
import { FormoAnalyticsProvider as FormoProviderBase, useFormo } from "@formo/analytics";
import { useAccountWallet } from "@b3dotfun/sdk/global-account/react";
import { useEffect, useRef } from "react";
import type { FC, ReactNode } from "react";

/**
 * Formo User Identification Component
 *
 * Identifies users in Formo by their wallet address.
 * Formo autocaptures wallet connects, signatures, and transactions.
 */
export function FormoIdentify() {
  const $ = _c(4);
  const analytics = useFormo();
  const {
    address
  } = useAccountWallet();
  const identifiedAddressRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== address || $[1] !== analytics) {
    t0 = () => {
      if (address && analytics && identifiedAddressRef.current !== address) {
        analytics.identify({
          address
        });
        identifiedAddressRef.current = address;
      }
    };
    t1 = [address, analytics];
    $[0] = address;
    $[1] = analytics;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}

/**
 * Formo Analytics Provider
 *
 * Wraps children with Formo analytics tracking.
 * `FormoIdentify` must render under `B3Provider` because it uses wallet hooks.
 */
export const FormoAnalyticsProvider: FC<{
  writeKey: string;
  children: ReactNode;
}> = t0 => {
  const $ = _c(3);
  const {
    writeKey,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== writeKey) {
    t1 = <FormoProviderBase writeKey={writeKey}>{children}</FormoProviderBase>;
    $[0] = children;
    $[1] = writeKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default FormoAnalyticsProvider;